import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  logo,
  menu_payment,
  menu_po,
  menu_user,
  productstock,
} from "../Images";

const getClassName = ({ isActive }) => {
  return isActive ? "nav-link active" : "nav-link";
};

const navlinks = {
  salesorder: (
    <li key="salesorder" className="nav-item nav-item-mt-custom">
      <NavLink to="/salesorder" className={getClassName}>
        <i className="fas fa-shopping-bag"></i>
        <span>Sales Order</span>
      </NavLink>
    </li>
  ),
  salesorderapproval: (
    <li key="salesorderapproval" className="nav-item nav-item-mt-custom">
      <NavLink to="/salesorderapproval" className={getClassName}>
        <i className="fas fa-clipboard-list"></i>
        <span>Sales Order Approval</span>
      </NavLink>
    </li>
  ),
  purchaseorder: (
    <li key="purchaseorder" className="nav-item nav-item-mt-custom">
      <NavLink to="/purchaseorder" className={getClassName}>
        <i className="fas fa-box"></i>
        <span>Purchase Order</span>
      </NavLink>
    </li>
  ),
  purchaseorderapproval: (
    <li key="purchaseorder" className="nav-item nav-item-mt-custom">
      <NavLink to="/purchaseorder" className={getClassName}>
        <img src={menu_po} />
        <span>PO Stock Verification</span>
      </NavLink>
    </li>
  ),
  delivery: (
    <li key="delivery" className="nav-item nav-item-mt-custom">
      <NavLink to="/delivery" className={getClassName}>
        <i className="fas fa-truck"></i>
        <span>Delivery</span>
      </NavLink>
    </li>
  ),
  inventorytransfer: (
    <li key="inventorytransfer" className="nav-item nav-item-mt-custom">
      <NavLink to="/inventorytransfer" className={getClassName}>
        <i className="fas fa-exchange-alt"></i>
        <span>Inventory Transfer</span>
      </NavLink>
    </li>
  ),
  operationalcost: (
    <li key="operationalcost" className="nav-item nav-item-mt-custom">
      <NavLink to="/operationalcost" className={getClassName}>
        <i className="fas fa-coins"></i>
        <span>Operational Cost</span>
      </NavLink>
    </li>
  ),
  dealerbanks: (
    <li key="dealerbanks" className="nav-item nav-item-mt-custom">
      <NavLink to="/dealerbanks" className={getClassName}>
        <img src={menu_payment} /> <span>Dealer Banks</span>{" "}
      </NavLink>
    </li>
  ),
  productstock: (
    <li key="productstock" className="nav-item nav-item-mt-custom">
      <NavLink to="/productstock/branch" className={getClassName}>
        <i className="fas fa-archive"></i>
        <span>Stock Ready</span>
      </NavLink>
    </li>
  ),
  mistock: (
    <li key="mistock" className="nav-item nav-item-mt-custom">
      <NavLink to="/mistock" className={getClassName}>
        <img src={productstock} /> <span>MI Stock Ready</span>{" "}
      </NavLink>
    </li>
  ),
  transactionmi: (
    <li key="transactionmi" className="nav-item nav-item-mt-custom">
      <NavLink to="/logs/transactions/mi" className={getClassName}>
        <i className="fa fa-file" /> <span>MI Transaction Logs</span>{" "}
      </NavLink>
    </li>
  ),
  transactionmhc: (
    <li key="transactionmhc" className="nav-item nav-item-mt-custom">
      <NavLink to="/logs/transactions/mhc" className={getClassName}>
        <i className="fa fa-file" /> <span>MHC Transaction Logs</span>
      </NavLink>
    </li>
  ),
  withdrawal: (
    <>
      <li key="withdrawal" className="nav-item nav-item-mt-custom">
        <NavLink to="/payment-gateway/withdrawal" className={getClassName}>
          <i className="fa fa-download" />
          <span>Payment Gateway Withdrawal</span>
        </NavLink>
      </li>
      <li key="balance_inquiry" className="nav-item nav-item-mt-custom">
        <NavLink to="/payment-gateway/balance-inquiry" className={getClassName}>
          <i className="fa fa-chart-bar" />
          <span>Balance Inquiry</span>
        </NavLink>
      </li>
    </>
  ),
};

const generalLinks = {
  user: (
    <li key="user" className="nav-item nav-item-mt-custom">
      <NavLink to="/users" className={getClassName}>
        <img src={menu_user} /> <span>User</span>
      </NavLink>
    </li>
  ),
  role: (
    <li key="role" className="nav-item nav-item-mt-custom">
      <NavLink to="/roles" className={getClassName}>
        <i className="fa fa-tags" /> <span>Role</span>
      </NavLink>
    </li>
  ),
  sync: (
    <li key="sync" className="nav-item nav-item-mt-custom">
      <NavLink to="/sync" className={getClassName}>
        <i className="fa fa-sync" /> <span>Sync SAP</span>
      </NavLink>
    </li>
  ),
  profile: (
    <li key="profile" className="nav-item nav-item-mt-custom">
      <NavLink to="/profile" className={getClassName}>
        <i className="fa fa-user" /> <span>Profile</span>
      </NavLink>
    </li>
  ),
};
const Sidebar = () => {
  const { privileges } = useSelector((state) => state.auth.userInfo);

  return (
    <div
      className="navbar-nav sidebar sidebar-dark accordion"
      id="accordionSidebar"
      style={{
        fontFamily: "Inter, sans-serif !important",
        backgroundColor: "#0a1929",
      }}
    >
      <a
        className="sidebar-brand d-flex align-items-center justify-content-center"
        href="/"
        style={{ position: "fixed", top: 0 }}
      >
        <div className="sidebar-brand-icon">
          <img src={logo} className="sidebar-logo" />
        </div>
        <div className="sidebar-brand-text mx-3">
          <div
            className="sidebar-brand-p"
            style={{
              fontWeight: "700",
              color: "white",
              fontSize: "1rem",
              textAlign: "left",
              lineHeight: "1",
            }}
          >
            MODENA
            <br />
            Retail
          </div>
        </div>
      </a>

      {/* <hr className="sidebar-divider my-0" /> */}
      <div
        className="box-sidebar"
        style={{
          position: "fixed",
          top: 0,
          marginTop: "4rem",
          width: "15rem",
          overflowY: "hidden",
          height: "90vh",
          color: "white !important",
        }}
      >
        <div
          className="sidebar-heading"
          style={{ fontWeight: "700", color: "white", fontSize: "1rem" }}
        >
          Menu
        </div>
        <li className="nav-item nav-item-mt-custom">
          <NavLink to="/dashboard" className={getClassName}>
            <i className="fa fa-home"></i>
            <span>Dashboard</span>
          </NavLink>{" "}
        </li>
        {(privileges || []).map((item, i) => {
          return item.access && navlinks[item.name];
        })}

        <div
          className="sidebar-heading"
          style={{
            fontWeight: "700",
            color: "white",
            fontSize: "1rem",
            marginTop: "1rem",
          }}
        >
          General Menu
        </div>
        {generalLinks["profile"]}
        {(privileges || []).map(
          (item, i) => item.access && generalLinks[item.name]
        )}
      </div>
    </div>
  );
};

export default Sidebar;
